import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"

const FooterWrapper = styled.footer`
  width: 100%;
  padding: 70px 0 93px;
  background-color: ${themeGet("colors.black")};
  z-index: 0;
  @media (max-width: 990px) {
    padding: 60px 0 82px;
  }

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 568px) {
      flex-direction: column;
    }
  }

  .logo-footer {
    max-width: 60px;
    @media (max-width: 568px) {
      margin-bottom: 68px;
    }
  }

  .right-col {
    .copyright {
      color: white;
      font-weight: 400;
      font-size: 20px;
    }
  }

  .backToTop {
    position: absolute;
    bottom: 30px;
    right: 0;

    img {
      width: 60px;
      @media (max-width: 990px) {
        width: 50px;
      }
    }
  }
`

export const SocialList = styled.ul`
  display: flex;
  align-items: center;
  @media (max-width: 568px) {
    justify-content: space-between;
  }

  li {
    margin-right: 17px;
    background-color: ${themeGet("colors.white")};
    border-radius: 50%;
    @media only screen and (max-width: 991px) {
      margin-right: 20px;
    }
    &:last-child {
      margin-right: 0;
    }

    a {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      color: ${themeGet("colors.black")};
      position: relative;
      padding: 5px;
      transition: all 0.3s ease;
      i {
        position: relative;
        z-index: 1;

        svg {
          width: 20px;
          height: auto;
        }
      }

      &:hover {
        color: ${themeGet("colors.mainBlue")};
      }
    }
  }
`

export default FooterWrapper
